module.exports = __webpack_public_path__ + "static/duplicateids-0f5846eaeebc787c2bec60d0b0f90460.png";